import {createContext, PropsWithChildren, useContext, useState} from 'react';

// Create a context for tertiary child identification
const TertiaryChildContext = createContext(false);

// Create a context provider component
export const TertiaryChildProvider = ({children, value = false}: PropsWithChildren<{ value: boolean }>) => {
    const [isTertiaryChild] = useState(value);

    return (
        <TertiaryChildContext.Provider value={isTertiaryChild}>
            {children}
        </TertiaryChildContext.Provider>
    );
};

// Create a hook to access the tertiary child context
export const useIsTertiaryChild = () => useContext(TertiaryChildContext);